// src/components/AreaContainer.js

import React from "react";
import { Button, Grid, TextField, Card, Accordion, AccordionSummary, Box } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {  useEffect } from 'react';
// import { Rectangle, Lshape, Ushape } from "../assets/images";
import Rectangle from "resources/tools/mitigation-zone/room-shape1.png";
import Lshape from "resources/tools/mitigation-zone/images/room-shape2.png";
import Ushape from "resources/tools/mitigation-zone/room-shape3.png";

const AreaCalculate = ({ calculateArea, selectedImage, selectedImageName, handleImageChange, dimensions, handleChange, isAreaCalculatorVisible, wallErrorMessages, setRoomArea}) => {
  useEffect(() => {
    const area = calculateArea();
    if(area > 0) {
      setRoomArea(area);
    }
    else{
      setRoomArea('');
    }
  }, [dimensions]);
  return (
    <Box sx={{ display: isAreaCalculatorVisible ? 'flex' : 'none !important', flexGrow: 1, width: '100%' }} className='areaContainer card'>
      <Accordion sx={{ width: '100%' }} defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon className="mitigation-expand-icon"/>} className='calculator-title'>
          <h3 style={{ width: '50%', float: 'left', margin: '0' }}>Room Size</h3>
          <h3 style={{width: '50%', paddingRight: '8px', textAlign: 'right', margin: '0'}}>Area: {calculateArea()} sq ft</h3>
        </AccordionSummary>
        <Box sx={{ display: 'flex', flexGrow: 1 }} className='areaContent'>
          <Box className='shape-images-container col-lg-6 col-md-12 col-12'>
            <div className='shapename' style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
              <h3>Room Shapes</h3>
              <h3>{selectedImageName}</h3>
            </div>
            <Grid item>
              <div className='shapebtn'>
                <Button
                  variant={selectedImage === Rectangle ? 'contained' : 'outlined'}
                  onClick={() => handleImageChange(Rectangle, 'Rectangle')}
                >
                  Rectangle
                </Button>
                <Button
                  variant={selectedImage === Lshape ? 'contained' : 'outlined'}
                  onClick={() => handleImageChange(Lshape, 'L shape')}
                >
                  L-Shaped
                </Button>
                <Button
                  variant={selectedImage === Ushape ? 'contained' : 'outlined'}
                  onClick={() => handleImageChange(Ushape, 'U shape')}
                >
                  U-Shaped
                </Button>
              </div>
            </Grid>
            <h3>Wall Dimensions</h3>
            <Grid item xs={8} sx={{ padding: '0', gap: '10px', textAlign: 'center' }} className="room-shapes-image-container">
              <img src={selectedImage} alt="Selected Shape" style={{ width: '70%', maxWidth: '400px' }} />
            </Grid>
          </Box>

          <Box sx={{ margin: "0", padding: "10px" }} className='shapeInputs col-lg-6 col-md-12 col-12'>
            <div className='mb-1'>
              <label>WALL HEIGHT</label>
              <div className="d-flex">
                <div style={{width: '50%'}}>
                  <div className="d-flex">
                    <TextField
                      type="number"
                      value={dimensions.heightFt}
                      onChange={(e) => handleChange(e, "heightFt")}
                      variant="outlined"
                      size="small"
                      sx={{ marginRight: 1 }}
                    /><span style={{ marginRight: "20px", paddingTop: "10px", display: "inline-block" }} className="unit">ft</span>
                  </div>
                  <span className="error-message">{wallErrorMessages["heightFt"]}</span>
                </div>
                <div style={{width: '50%'}}>
                  <div className="d-flex">
                    <TextField
                      type="number"
                      value={dimensions.heightIn}
                      onChange={(e) => handleChange(e, "heightIn")}
                      variant="outlined"
                      size="small"
                    /><span style={{ marginLeft: "10px", paddingTop: "10px", display: "inline-block" }} className="unit">in</span>
                  </div>
                  <span className="error-message">{wallErrorMessages["heightIn"]}</span>
                </div>
              </div>
            </div>
            <label style={{ margin: "18px 0" }}>WALL LENGTH</label>
            <div className='wall_inch mb-1'>
              <div className='mb-1 col-6'>
                <label>Wall 1 </label>
                <div className="d-flex">
                  <div style={{width: '50%'}}>
                    <div className="d-flex">
                        <TextField
                          type="number"
                          value={dimensions.wall1Ft}
                          onChange={(e) => handleChange(e, "wall1Ft")}
                          variant="outlined"
                          size="small"
                          sx={{ marginRight: 1 }}
                        /><span style={{ marginRight: "10px", paddingTop: "10px", display: "inline-block" }} className="unit">ft</span>
                    </div>
                    <span className="error-message">{wallErrorMessages["wall1Ft"]}</span>
                  </div>

                  <div style={{width: '50%'}}>
                    <div className="d-flex">
                      <TextField
                        type="number"
                        value={dimensions.wall1In}
                        onChange={(e) => handleChange(e, "wall1In")}
                        variant="outlined"
                        size="small"
                      /><span style={{ marginLeft: "5px", paddingTop: "10px", display: "inline-block", marginRight: "15px" }} className="unit">in</span>
                    </div>
                    <span className="error-message">{wallErrorMessages["wall1In"]}</span>
                  </div>
                </div>
              </div>

              <div className='mb-1 col-6'>
                <label>Wall 2 </label>
                <div className="d-flex">
                  <div style={{width: '50%'}}>
                    <div className="d-flex">
                      <TextField
                        type="number"
                        value={dimensions.wall2Ft}
                        onChange={(e) => handleChange(e, "wall2Ft")}
                        variant="outlined"
                        size="small"
                        sx={{ marginRight: 1 }}
                      /><span style={{ marginRight: "10px", paddingTop: "10px", display: "inline-block" }} className="unit">ft</span>
                    </div>
                    <span className="error-message">{wallErrorMessages["wall2Ft"]}</span>
                  </div>
                  <div style={{width: '50%'}}>
                    <div className="d-flex">
                      <TextField
                        type="number"
                        value={dimensions.wall2In}
                        onChange={(e) => handleChange(e, "wall2In")}
                        variant="outlined"
                        size="small"
                      /><span style={{ marginLeft: "10px", paddingTop: "10px", display: "inline-block" }} className="unit">in</span>
                   </div>
                   <span className="error-message">{wallErrorMessages["wall2In"]}</span>
                  </div>
                </div>
              </div>
            </div>
            {selectedImageName === "Rectangle" && <div className='wall_inch'>
              <div className='mb-1 col-6'>
                <label>Wall 3</label>
                <div className="d-flex">
                  <div style={{width: '50%'}}>
                    <div className="d-flex">
                      <TextField
                        type="number"
                        value={Number(dimensions.wall1Ft)}
                        onChange={(e) => handleChange(e, "wall3Ft")}
                        variant="outlined"
                        size="small"
                        sx={{ marginRight: 1 }}
                        disabled
                      /><span style={{ marginRight: "10px", paddingTop: "10px", display: "inline-block" }} className="unit">ft</span>
                    </div>
                    <span className="error-message">{wallErrorMessages["wall3Ft"]}</span>
                  </div>
                  <div style={{width: '50%'}}> 
                    <div className="d-flex">
                      <TextField
                        type="number"
                        value={Number(dimensions.wall1In)}
                        onChange={(e) => handleChange(e, "wall3In")}
                        variant="outlined"
                        size="small"
                        disabled
                      /><span style={{ marginLeft: "5px", paddingTop: "10px", display: "inline-block", marginRight: "15px" }} className="unit">in</span>
                    </div>
                    <span className="error-message">{wallErrorMessages["wall3In"]}</span>
                  </div>
                </div>
              </div>

              <div className='mb-1 col-6'>
                <label>Wall 4</label>
                <div className="d-flex">
                  <div style={{width: '50%'}}>
                    <div className="d-flex">
                      <TextField
                        type="number"
                        value={Number(dimensions.wall2Ft)}
                        onChange={(e) => handleChange(e, "wall4Ft")}
                        variant="outlined"
                        size="small"
                        sx={{ marginRight: 1 }}
                        disabled
                      /><span style={{ marginRight: "10px", paddingTop: "10px", display: "inline-block" }} className="unit">ft</span>
                    </div>
                    <span className="error-message">{wallErrorMessages["wall4Ft"]}</span>
                  </div>
                  <div style={{width: '50%'}}>
                    <div className="d-flex">
                      <TextField
                        type="number"
                        value={Number(dimensions.wall2In)}
                        onChange={(e) => handleChange(e, "wall4In")}
                        variant="outlined"
                        size="small"
                        disabled
                      /><span style={{ marginLeft: "10px", paddingTop: "10px", display: "inline-block" }} className="unit">in</span>
                    </div>
                    <span className="error-message">{wallErrorMessages["wall4In"]}</span>
                  </div>
                </div>
              </div>
            </div>}

            {selectedImageName !== "Rectangle" && (
              <>
                <div className='wall_inch mb-1'>
                  <div className='mb-1 col-6'>
                    <label>Wall 3</label>
                    <div className="d-flex">
                      <div style={{width: '50%'}}>
                        <div className="d-flex">
                          <TextField
                            type="number"
                            value={dimensions.wall3Ft}
                            onChange={(e) => handleChange(e, "wall3Ft")}
                            variant="outlined"
                            size="small"
                            sx={{ marginRight: 1 }}
                          /><span style={{ marginRight: "10px", paddingTop: "10px", display: "inline-block" }} className="unit">ft</span>
                        </div>
                        <span className="error-message">{wallErrorMessages["wall3Ft"]}</span>
                      </div>
                      <div style={{width: '50%'}}>
                        <div className="d-flex">
                          <TextField
                            type="number"
                            value={dimensions.wall3In}
                            onChange={(e) => handleChange(e, "wall3In")}
                            variant="outlined"
                            size="small"
                          /><span style={{ marginLeft: "5px", paddingTop: "10px", display: "inline-block", marginRight: "15px" }} className="unit">in</span>
                        </div>
                        <span className="error-message">{wallErrorMessages["wall3In"]}</span>
                      </div>
                    </div>
                  </div>

                  <div className='mb-1 col-6'>
                    <label>Wall 4 </label>
                    <div className="d-flex">
                      <div style={{width: '50%'}}>
                        <div className="d-flex">
                          <TextField
                            type="number"
                            value={dimensions.wall4Ft}
                            onChange={(e) => handleChange(e, "wall4Ft")}
                            variant="outlined"
                            size="small"
                            sx={{ marginRight: 1 }}
                          /><span style={{ marginRight: "10px", paddingTop: "10px", display: "inline-block" }} className="unit">ft</span>
                        </div>
                        <span className="error-message">{wallErrorMessages["wall4Ft"]}</span>
                      </div>
                      <div style={{width: '50%'}}>  
                        <div className="d-flex">
                          <TextField
                            type="number"
                            value={dimensions.wall4In}
                            onChange={(e) => handleChange(e, "wall4In")}
                            variant="outlined"
                            size="small"
                          /><span style={{ marginLeft: "10px", paddingTop: "10px", display: "inline-block" }} className="unit">in</span>
                        </div>
                        <span className="error-message">{wallErrorMessages["wall4In"]}</span>
                      </div>
                    </div>
                  </div>
                </div>
                {selectedImageName === "L shape" && <div className='wall_inch'>
                  <div className='mb-1 col-6'>
                    <label>Wall 5</label>
                    <div className="d-flex">
                      <div style={{width: '50%'}}>
                        <div className="d-flex">
                          <TextField
                            type="number"
                            value={Number(dimensions.wall1Ft) + Number(dimensions.wall3Ft)}
                            onChange={(e) => handleChange(e, "wall5Ft")}
                            variant="outlined"
                            size="small"
                            sx={{ marginRight: 1 }}
                            disabled
                          /><span style={{ marginRight: "10px", paddingTop: "10px", display: "inline-block" }} className="unit">ft</span>
                        </div>
                        <span className="error-message">{wallErrorMessages["wall5Ft"]}</span>
                      </div>
                      <div style={{width: '50%'}}>
                        <div className="d-flex">
                          <TextField
                            type="number"
                            value={Number(dimensions.wall1In) + Number(dimensions.wall3In)}
                            onChange={(e) => handleChange(e, "wall5In")}
                            variant="outlined"
                            size="small"
                            disabled
                          /><span style={{ marginLeft: "5px", paddingTop: "10px", display: "inline-block", marginRight: "15px" }} className="unit">in</span>
                        </div>
                        <span className="error-message">{wallErrorMessages["wall5In"]}</span>
                      </div>
                    </div>
                  </div>

                  <div className='mb-1 col-6'>
                    <label>Wall 6</label>
                    <div className="d-flex">
                      <div style={{width: '50%'}}>
                        <div className="d-flex">
                          <TextField
                            type="number"
                            value={Number(dimensions.wall2Ft) + Number(dimensions.wall4Ft)}
                            onChange={(e) => handleChange(e, "wall6Ft")}
                            variant="outlined"
                            size="small"
                            sx={{ marginRight: 1 }}
                            disabled
                          /><span style={{ marginRight: "10px", paddingTop: "10px", display: "inline-block" }} className="unit">ft</span>
                        </div>
                        <span className="error-message">{wallErrorMessages["wall6Ft"]}</span>
                      </div>
                      <div style={{width: '50%'}}>
                        <div className="d-flex">
                          <TextField
                            type="number"
                            value={Number(dimensions.wall2In) + Number(dimensions.wall4In)}
                            onChange={(e) => handleChange(e, "wall6In")}
                            variant="outlined"
                            size="small"
                            disabled
                          /><span style={{ marginLeft: "10px", paddingTop: "10px", display: "inline-block" }} className="unit">in</span>
                        </div>
                        <span className="error-message">{wallErrorMessages["wall6In"]}</span>
                      </div>
                    </div>
                  </div>
                </div>}
              </>
            )}

            {selectedImageName === "U shape" && (
              <>
                <div className='wall_inch'>
                  <div className='mb-1 col-6'>
                    <label>Wall 5 </label>
                    <div className="d-flex">
                      <div style={{width: '50%'}}>
                        <div className="d-flex">
                          <TextField
                            type="number"
                            value={dimensions.wall5Ft}
                            onChange={(e) => handleChange(e, "wall5Ft")}
                            variant="outlined"
                            size="small"
                            sx={{ marginRight: 1 }}
                          /><span style={{ marginRight: "10px", paddingTop: "10px", display: "inline-block" }} className="unit">ft</span>
                        </div>
                        <span className="error-message">{wallErrorMessages["wall5Ft"]}</span>
                      </div>
                      <div style={{width: '50%'}}>
                        <div className="d-flex">
                          <TextField
                            type="number"
                            value={dimensions.wall5In}
                            onChange={(e) => handleChange(e, "wall5In")}
                            variant="outlined"
                            size="small"
                          /><span style={{ marginLeft: "5px", paddingTop: "10px", display: "inline-block", marginRight: "15px" }} className="unit">in</span>
                        </div>
                        <span className="error-message">{wallErrorMessages["wall5In"]}</span>
                      </div>
                    </div>
                  </div>

                  <div className='mb-1 col-6'>
                    <label>Wall 6 </label>
                    <div className="d-flex">
                      <div style={{width: '50%'}}>
                        <div className="d-flex">
                          <TextField
                            type="number"
                            value={dimensions.wall6Ft}
                            onChange={(e) => handleChange(e, "wall6Ft")}
                            variant="outlined"
                            size="small"
                            sx={{ marginRight: 1 }}
                          /><span style={{ marginRight: "10px", paddingTop: "10px", display: "inline-block" }} className="unit">ft</span>
                        </div>
                        <span className="error-message">{wallErrorMessages["wall6Ft"]}</span>
                      </div>
                      <div style={{width: '50%'}}>
                        <div className="d-flex">
                          <TextField
                            type="number"
                            value={dimensions.wall6In}
                            onChange={(e) => handleChange(e, "wall6In")}
                            variant="outlined"
                            size="small"
                          /><span style={{ marginLeft: "10px", paddingTop: "10px", display: "inline-block" }} className="unit">in</span>
                        </div>
                        <span className="error-message">{wallErrorMessages["wall6In"]}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='wall_inch'>
                  <div className='mb-1 col-6'>
                    <label>Wall 7</label>
                    <div className="d-flex">
                      <div style={{width: '50%'}}>
                        <div className="d-flex">
                          <TextField
                            type="number"
                            value={Number(dimensions.wall1Ft) + Number(dimensions.wall3Ft) + Number(dimensions.wall5Ft)}
                            onChange={(e) => handleChange(e, "wall7Ft")}
                            variant="outlined"
                            size="small"
                            sx={{ marginRight: 1 }}
                            disabled
                          /><span style={{ marginRight: "10px", paddingTop: "10px", display: "inline-block" }} className="unit">ft</span>
                        </div>
                        <span className="error-message">{wallErrorMessages["wall7Ft"]}</span>
                      </div>
                      <div style={{width: '50%'}}>
                        <div className="d-flex">
                          <TextField
                            type="number"
                            value={Number(dimensions.wall1In) + Number(dimensions.wall3In) + Number(dimensions.wall5In)}
                            onChange={(e) => handleChange(e, "wall7In")}
                            variant="outlined"
                            size="small"
                            disabled
                          /><span style={{ marginLeft: "5px", paddingTop: "10px", display: "inline-block", marginRight: "15px" }} className="unit">in</span>
                        </div>
                        <span className="error-message">{wallErrorMessages["wall7In"]}</span>
                      </div>
                    </div>
                  </div>

                  <div className='mb-1 col-6'>
                    <label>Wall 8</label>
                    <div className="d-flex">
                      <div style={{width: '50%'}}>
                        <div className="d-flex">
                          <TextField
                            type="number"
                            value={Number(dimensions.wall2Ft) + Number(dimensions.wall4Ft) + Number(dimensions.wall6Ft)}
                            onChange={(e) => handleChange(e, "wall8Ft")}
                            variant="outlined"
                            size="small"
                            sx={{ marginRight: 1 }}
                            disabled
                          /><span style={{ marginRight: "10px", paddingTop: "10px", display: "inline-block" }} className="unit">ft</span>
                        </div>
                        <span className="error-message">{wallErrorMessages["wall8Ft"]}</span>
                      </div>
                      <div style={{width: '50%'}}>
                        <div className="d-flex">
                          <TextField
                            type="number"
                            value={Number(dimensions.wall2In) + Number(dimensions.wall4In) + Number(dimensions.wall6In)}
                            onChange={(e) => handleChange(e, "wall8In")}
                            variant="outlined"
                            size="small"
                            disabled
                          /><span style={{ marginLeft: "10px", paddingTop: "10px", display: "inline-block" }} className="unit">in</span>
                        </div>
                        <span className="error-message">{wallErrorMessages["wall8In"]}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </Box>
        </Box>
      </Accordion>
    </Box>
  );
};

export default AreaCalculate;
